module.exports = __webpack_public_path__ + "static/media/dogs.da57f9df.jpg";